import { memo, useCallback, useRef, useState } from "react";
import PropTypes from "prop-types";
import { messagePropType } from "app/utils/propTypes";
import "./TravellersRoomButton.scss";
import classNames from "classnames";
import { scrollToElement } from "app/utils/scroller";
import TravellersRoomForm from "app/pages/SmartDP/Search/TravellersRoomInput/TravellersRoomForm";
import { Drawer } from "app/pages/.shared/Drawer";
import { FormattedMessage } from "react-intl";
import IconClose from "app/pages/.shared/IconClose";

const TravellersRoomDrawerButton = props => {
	const [open, setOpen] = useState(false);

	const {
		label,
		className,
		icon,
		initialValues = [],
		valueToDisplay,
		onConfirmation = () => {},
		id,
	} = props;
	const ref = useRef();

	const handleValidation = useCallback(
		values => {
			setOpen(false);
			if (ref && ref.current) {
				scrollToElement({ element: ref.current, offset: -300, disableSmoothScroll: false });
			}
			onConfirmation(values.occupancies);
		},
		[ref.current]
	);

	const handleOpen = useCallback(() => {
		setOpen(true);
	}, []);

	const handleClose = useCallback(() => {
		setOpen(false);
	}, []);

	const inputClassName = classNames(
		"travellers-room-button",
		"travellers-room-button--touched",
		className,
		{
			"travellers-room-button--with-icon": icon,
			"travellers-room-button--opened": open,
		}
	);

	const Form = (
		<TravellersRoomForm initialValues={initialValues} handleValidation={handleValidation} />
	);

	return (
		<div className={inputClassName} ref={ref} id={id}>
			<label className="travellers-room-button__label">{label}</label>
			<div
				onClick={handleOpen}
				className="travellers-room-button__input"
				data-testid="travellers-room-button"
			>
				{icon && <div className="travellers-room-button__icon">{icon}</div>}
				{valueToDisplay}
			</div>
			<Drawer
				drawerClassName="travellers-room-button__drawer"
				isOpen={open}
				onClose={handleClose}
				direction={"rtl"}
			>
				<div className="travellers-room-button__header">
					<FormattedMessage id="sdp.search.occupancies.title" tagName="h3" />
					<div onClick={handleClose} className="travellers-room-button__header-icon">
						<IconClose width={24} height={24} />
					</div>
				</div>
				{Form}
			</Drawer>
		</div>
	);
};

TravellersRoomDrawerButton.propTypes = {
	label: messagePropType,
	className: PropTypes.string,
	icon: PropTypes.element,
	valueToDisplay: PropTypes.element,
	onConfirmation: PropTypes.func,
	initialValues: PropTypes.array,
	id: PropTypes.string,
};

export default memo(TravellersRoomDrawerButton);
